import {Component, OnDestroy, OnInit} from '@angular/core';
import {NewsService} from '@iw-shop/news/services/news.service';
import {select, Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {getSelectedCustomer} from '@store/selectors/user.selector';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {ApiNews} from "@api/news";
import {Customer} from "@iw-shop/customer/models/customer";

@Component({
    selector: 'iw-shop-news-list',
    standalone: false,
    templateUrl: './news-list.component.html',
    styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit, OnDestroy {

    destroy$: Subject<boolean> = new Subject<boolean>();

    selectedCustomer$?: Observable<Customer | undefined>;
    loading: boolean = true;
    news: ApiNews[] = [];

    priceGroup?: string;

    constructor(private store: Store<AppState>, private newsService: NewsService) {
    }

    ngOnInit(): void {
        this.selectedCustomer$ = this.store.pipe(select(getSelectedCustomer));
        this.selectedCustomer$
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                res => {
                    if (res?.priceGroup) {
                        this.priceGroup = res.priceGroup;
                    }
                    this.loadNews();
                }
            )

    }

    loadNews() {
        this.newsService.get({news: {}})
            .subscribe(
            {
                next: (r) => {
                    this.news = [];
                    this.loading = false;
                    if (r.result?.news.data) {
                        r.result.news.data.map(
                            n => {
                                if (!n.priceGroups ||
                                    n.priceGroups.length == 0 ||
                                    n.priceGroups.includes(this.priceGroup || '')

                                ) {
                                    this.news.push(n);
                                }
                            }
                        )
                    }
                },
                error: () => {
                    this.loading = false;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
